import { Injectable } from '@angular/core';

import { Observable, Subject } from '../util/rxjs';
import { Action, Dialog, DialogMessage } from './dialog.model';

class DialogBuilder {
  private dialog: Partial<Dialog>;

  constructor(private service: DialogService) {
    this.dialog = {
      onDismiss: () => {}
    };
  }

  title(text: string) {
    this.dialog.title = text;
    return this;
  }

  messages(...messages: DialogMessage[]) {
    this.dialog.messages = messages;
    return this;
  }

  actions(...actions: Action[]) {
    this.dialog.actions = actions;
    return this;
  }

  onDismiss(action: () => void) {
    this.dialog.onDismiss = action;
    return this;
  }

  show() {
    this.service.show(this.dialog as Dialog);
  }
}

@Injectable()
export class DialogService {
  dialogs$: Observable<Dialog>;
  private dialogStream = new Subject<Dialog>();

  constructor() {
    this.dialogs$ = this.dialogStream.asObservable();
  }

  show(dialog: Dialog) {
    if (dialog && document) {
      const body = document.querySelector('body') as HTMLElement;
      body.classList.add('disable-scrolling');
    }
    this.dialogStream.next(dialog);
  }

  dismiss() {
    if (document) {
      const body = document.querySelector('body') as HTMLElement;
      body.classList.remove('disable-scrolling');
    }
    this.dialogStream.next(undefined);
  }

  build() {
    return new DialogBuilder(this);
  }

  ok(title: string, ...messages: DialogMessage[]) {
    return new DialogBuilder(this)
      .actions({ name: 'Dialog.ok', execute: () => {} })
      .title(title)
      .messages(...messages);
  }

  confirmation({ confirmName, onConfirmed }: { confirmName: string, onConfirmed: () => void }) {
    return new DialogBuilder(this)
      .actions({ name: confirmName, execute: onConfirmed }, { name: 'Dialog.cancel', execute: () => {}, secondary: true });
  }
}
